module.exports = __webpack_public_path__ + "img/Dominica.e3a11bff.png";